import React, { useEffect, useState } from 'react';

const WhatsAppBulkSender = () => {
  const [status, setStatus] = useState('Initializing...');

  useEffect(() => {
    // Define the async function inside useEffect
    const sendBulkMessage = async () => {
      try {
        setStatus('Sending message...');

        // Format current date and time
        const currentDateTime = new Date().toLocaleString();
        const customMessage = `Test Message\nSent at: ${currentDateTime}`;

        // Construct the static payload with dynamic message
        const payload = {
          deviceId: "919909345328",
          numbers: "919558001712,917383360300",
          message: customMessage
        };

        // Make the POST request
        const response = await fetch('https://whatsapp.hlgroups.in/api/send-bulk', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'my_secret_key_123'
          },
          body: JSON.stringify(payload)
        });

        // Parse the JSON response
        const data = await response.json();

        // Log the response and status to the console for debugging
        console.log('HTTP Status Code:', response.status);
        console.log('API Response Data:', data);

        if (response.ok) {
          setStatus('API call completed successfully! Check console for the response.');
        } else {
          setStatus(`API call failed with status: ${response.status}. Check console.`);
        }
      } catch (error) {
        // Catch and log any network or execution errors
        console.error('Error occurred while calling the API:', error);
        setStatus('A network error occurred. Check console for details.');
      }
    };

    // Execute the function immediately when the component mounts
    sendBulkMessage();
    
  }, []); // The empty array ensures this only runs once on page load/reload

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto', fontFamily: 'system-ui, sans-serif' }}>
      <h2>WhatsApp API Trigger</h2>
      <div style={{ 
        padding: '15px', 
        backgroundColor: '#f3f4f6', 
        borderRadius: '8px',
        borderLeft: '4px solid #25D366'
      }}>
        <strong>Status:</strong> {status}
      </div>
      <p style={{ fontSize: '14px', color: '#666', marginTop: '15px' }}>
        Press <code>F12</code> or right-click and select <strong>Inspect</strong>, then go to the <strong>Console</strong> tab to view the API response logs.
      </p>
    </div>
  );
};

export default WhatsAppBulkSender;